import LeftArrow from "Assets/Icons/LeftArrow";
import NotificationBox from "Components/CommonComponents/NotificationsBar/NotificationBox";
import Typography from "Components/CommonComponents/Typography";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import { MainPageDiv } from "utilFunctions/shared/StyledComponent/StyledComponent";
import { UserInfoContext } from "Context/CommonContext";
import { useGetApi } from "utilFunctions/CustomHooks/useGetAPI";
import {
  BASE_URL,
  USER_NOTIFICATIONS,
} from "utilFunctions/Constants/urlConstants";
import InfiniteScroll from "react-infinite-scroll-component";
import { List, Skeleton } from "antd";
import NotiificationNoDataIcon from "Assets/Icons/NotificationNoDataIcon";
const StyledSpan = styled<any>("span")`
  color: var(--Grey-60, #757575);
  font-size: ${({ screen }: any) =>
    ["xxl", "xl", "lg"].includes(screen) ? "16px" : "8px"};
  font-style: normal;
  font-weight: 400;
  margin-top: 16px;
`;
const StyledDiv = styled<any>("div")`
  border-radius: ${({ screen }: any) =>
    ["xxl", "xl", "lg"].includes(screen) ? "8px" : "0px"};
  background: #fff;
  padding: 16px;
  height: ${({ screen }: any) =>
    ["xxl", "xl", "lg"].includes(screen)
      ? "calc(100vh - 167px)"
      : "calc(100vh - 126px)"};
  overflow: auto;
`;
const StyledMainDiv = styled<any>("div")`
  background: #fff;
  padding: 16px;
  display: flex;
  align-items: center;
  color: var(--Grey-80, #333);
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px; /* 175% */
  border-radius: ${({ screen }: any) =>
    ["xxl", "xl", "lg"].includes(screen) ? "8px" : "0px"};
`;
const UserNotifications = (props: any) => {
  const { height } = props;
  const { screen }: any = useWindowSize();
  const [notifications, setNotifications] = useState<any>([]);
  const navigate = useNavigate();
  const userInfo = useContext<any>(UserInfoContext);
  const [limit] = useState<number>(10);
  const [offset, setOffSet] = useState<number>(0);
  const [hasMore, setHasMore] = useState<boolean>(false);
  const { makeRequest: GetNotifications, loading } = useGetApi(
    (searchData: any) => {
      if (
        searchData &&
        searchData != null &&
        searchData["data"] &&
        searchData["data"].length
      ) {
        setNotifications((previous: any) => {
          const newNotifications = searchData["data"].filter(
            (newNotification: any) => {
              return !previous.some(
                (existingNotification: any) =>
                  existingNotification.attachmentLink ===
                    newNotification.attachmentLink &&
                  existingNotification.createdOn ===
                    newNotification.createdOn &&
                  existingNotification.messageBody ===
                    newNotification.messageBody &&
                  existingNotification.type === newNotification.type
              );
            }
          );

          // Return the updated notifications list
          return [...previous, ...newNotifications];
        });

        setHasMore(
          searchData["data"] && searchData["data"].length > 0 ? true : false
        );
      }
    },
    (error: any) => {
      onFetchError(error);
    }
  );
  const onFetchError = (error: any) => {
    console.log("erorr onFetchError", error);
    setHasMore(false);
    if (offset == 0) {
      // setSuggestions([]);
    } else {
      setOffSet(0);
    }
  };

  console.log(userInfo);
  useEffect(() => {
    if (userInfo.employeeId) {
      const url =
        BASE_URL +
        USER_NOTIFICATIONS +
        "?facultyId=" +
        userInfo.employeeId +
        "&limit=" +
        limit +
        "&offset=" +
        0;
      GetNotifications(url);
    }
  }, [userInfo]);
  const nextHandler = () => {
    const newOffset = offset + limit;
    setOffSet((previous) => previous + limit);
    const url =
      BASE_URL +
      USER_NOTIFICATIONS +
      "?facultyId=" +
      userInfo.employeeId +
      "&limit=" +
      limit +
      "&offset=" +
      newOffset;
    GetNotifications(url);
  };
  return (
    <MainPageDiv screen={screen}>
      <StyledMainDiv screen={screen}>
        <LeftArrow
          className={"cursorHoverCSS mr-3"}
          onClick={() => {
            navigate("/admin/dashboard", {
              replace: true,
              state: {
                selectedStudent: null,
              },
            });
          }}
        />
        <Typography variant={"h6"} color="black">
          Notifications
        </Typography>
      </StyledMainDiv>
      {notifications && notifications.length ? (
        <StyledDiv screen={screen}>
          <div
            id="scrollableDiv"
            style={{
              height: height ? height : "100%",
              overflow: "auto",
            }}
          >
            <InfiniteScroll
              dataLength={notifications.length}
              next={nextHandler}
              hasMore={hasMore}
              loader={
                loading ? (
                  <Skeleton avatar paragraph={{ rows: 1 }} active />
                ) : null
              }
              scrollableTarget="scrollableDiv"
            >
              <List
                dataSource={notifications}
                renderItem={(ele: any, index: number) => (
                  <List.Item key={ele.email}>
                    <NotificationBox
                      key={ele.createdOn + index}
                      imageUrl={ele.attachmentLink}
                      primaryMessage={ele?.type}
                      message={ele?.messageBody}
                      date={ele?.createdOn}
                    ></NotificationBox>
                  </List.Item>
                )}
              />
            </InfiniteScroll>
          </div>
        </StyledDiv>
      ) : (
        <StyledDiv screen={screen}>
          <div
            className={
              "d-flex justify-content-center align-items-center flex-column h-100"
            }
            style={{
              background: "#F5F5F5",
            }}
          >
            <div>
              <NotiificationNoDataIcon />
            </div>
            <div className="d-flex align-items-center flex-column">
              <StyledSpan screen={screen}>
                Notifications data not available
              </StyledSpan>
            </div>
          </div>
        </StyledDiv>
      )}
    </MainPageDiv>
  );
};

export default UserNotifications;
